import { uniqueId } from 'lodash';

export enum SnackBarColorSet {
  BASE = 'base',
  NEGATIVE = 'negative',
}

export enum ACTION_TYPES {
  ADD = 'add',
  REMOVE = 'remove',
}

export type AddAction = {
  type: ACTION_TYPES.ADD;
  message: string;
  id: string;
  colorSet?: SnackBarColorSet;
};

export type RemoveAction = { type: ACTION_TYPES.REMOVE; id: string };

export type MessageActions = AddAction | RemoveAction;

export const buildAddSnackbarAction = (
  message: string,
  colorSet: SnackBarColorSet = SnackBarColorSet.BASE,
): AddAction => ({
  type: ACTION_TYPES.ADD,
  id: uniqueId('snackbar-'),
  message,
  colorSet,
});

export const buildRemoveSnackbarAction = (id: string): RemoveAction => ({
  type: ACTION_TYPES.REMOVE,
  id,
});
